import { ThumbsUpIcon, HeartIcon, LaughIcon, FrownIcon, AngryIcon } from "lucide-vue-next";

export enum ProfileTopicReactionContentEnum {
  LIKE = '👍',
  LOVE = '❤️',
  HAHA = '😆',
  // WOW = '😮',
  SAD = '😢',
  ANGRY = '😡'
}

export const profileTopicReactionLabels = {
  [ProfileTopicReactionContentEnum.LIKE]: 'Curtir',
  [ProfileTopicReactionContentEnum.LOVE]: 'Amei',
  [ProfileTopicReactionContentEnum.HAHA]: 'Haha',
  // [ProfileTopicReactionContentEnum.WOW]: 'Uau',
  [ProfileTopicReactionContentEnum.SAD]: 'Triste',
  [ProfileTopicReactionContentEnum.ANGRY]: 'Grr'
};

export const profileTopicReactionIcons = {
  [ProfileTopicReactionContentEnum.LIKE]: ThumbsUpIcon,
  [ProfileTopicReactionContentEnum.LOVE]: HeartIcon,
  [ProfileTopicReactionContentEnum.HAHA]: LaughIcon,
  // [ProfileTopicReactionContentEnum.WOW]: Suprised,
  [ProfileTopicReactionContentEnum.SAD]: FrownIcon,
  [ProfileTopicReactionContentEnum.ANGRY]: AngryIcon
};